export default class RemoteAssets {
  public static benefitImageUrl(reference: string): string {
    return this.imageUrl('advantages', reference);
  }

  public static benefitCategoryImageUrl(reference: string): string {
    return this.imageUrl('advantages_categories', reference);
  }

  private static imageUrl(type: string, reference: string): string {
    if (!reference) return '';
    else return `${process.env.VUE_APP_IMG_BASEURL}/img/${type}/${reference}`;
  }
}
